<template>
    <div class="chart-bar">
        <div
            v-for="(fillItem, fillItemIndex) in fillValuesPercent"
            :key="fillItemIndex"
            :style="{
                width: `${fillItem}%`, 
                background: getFillColor(fillItemIndex)
            }"
            class="chart-bar__fill"
        >
        </div>
    </div>
</template>

<script>
export default {
    name: 'TableChartBar',
    /**
     * входные данные компонента
     * @property {number} totalValue - значение 100%
     * @property {Array} fillValues - значение для шкалы гистограммы
     */
    props: {
        totalValue: {
            type: Number,
            default: 0
        },
        fillValues: {
            type: Array,
            default: () => ([])
        }
    },
    /**
     * данные компонента
     * @property {Array} fillColors - цвета для гистограммы
     */
    data: () => ({
        fillColors: ['#f1f158', '#97deef', '#67e271']
    }),
    computed: {
        /**
         * шкала гистограммы в процентах
         * @returns {Number}
         */
        fillValuesPercent() {
            let fillValuesPercent = this.fillValues.map((fillValue) => {
                let total = Number(this.totalValue) > 0 ? Number(this.totalValue) : 1;
                let fill = Number(fillValue) > 0 ? Number(fillValue) : 0;
                return Math.ceil(fill / total * 100);
            });
            return fillValuesPercent;
        }
    },
    methods: {
        /**
         * получить цвет для сектора гистограммы
         * @param {number} fillItemIndex - индекс сектора
         * @returns {string}
         */
        getFillColor(fillItemIndex = 0) {
            return this.fillValuesPercent.length === 1 ? this.fillColors[this.fillColors.length - 1] : this.fillColors[fillItemIndex];
        }
    }
}
</script>

<style lang="scss" scoped>
    .chart-bar {
        width: 100%;
        height: 6px;
        border-radius: 4px;
        background: #e8ebef;
        margin: 4px 0 0 0;
        display: flex;
        overflow: hidden;
    }
    .chart-bar__fill {
        height: 100%;
        // background: #67e271;
    }
</style>